import { UploadDto } from "generated";
import Text from "@ingka/text";
import Column from "./Column";

type Props = {
  title: string;
  subTitle?: string;
  uploadsGroup: UploadDto[][];
  onClick: (uploadId: number) => void;
};

const ColumnGroup = ({ onClick, title, subTitle, uploadsGroup }: Props) => {
  const [uploads, splitUploads = [], ...otherUploads] = uploadsGroup;
  const flattenedOtherUploads = otherUploads.flat();

  const splitUploadsHasItems = splitUploads.length > 0;
  const uploadsHasItems = uploads.length > 0;

  const titleStyle = splitUploadsHasItems ? `flex-[1_1_75%]` : `flex-[1_1_0%]`;
  const subTitleStyle = splitUploadsHasItems
    ? `flex-[0_0_25%]`
    : `flex-[1_0_100%]`;

  return (
    <div className="flex h-[calc(100vh-13rem)] max-h-[calc(100vh-13rem)] flex-col overflow-hidden">
      <Text tagName="h2" headingSize="xs" className="mb-space100 flex-shrink-0">
        {title}
      </Text>
      <div
        className={`flex ${titleStyle} min-h-0 flex-col overflow-y-auto bg-[#F1F4FE] p-space100`}
      >
        {subTitle ? (
          <>
            {splitUploadsHasItems && (
              <div className="mb-space100 flex min-h-0 flex-grow flex-col overflow-y-auto">
                <Column
                  title={title}
                  uploads={splitUploads}
                  onClick={onClick}
                />
              </div>
            )}
            {uploadsHasItems && (
              <div
                className={`flex ${subTitleStyle} min-h-0 flex-col overflow-y-auto`}
              >
                <Text
                  tagName="h2"
                  headingSize="xs"
                  className="mb-space100 flex-shrink-0"
                >
                  {subTitle}
                </Text>
                <div className="flex min-h-0 flex-grow flex-col overflow-y-auto">
                  <Column
                    title={subTitle}
                    uploads={uploads}
                    onClick={onClick}
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <Column
            title={title}
            uploads={[...uploads, ...splitUploads, ...flattenedOtherUploads]}
            onClick={onClick}
          />
        )}
      </div>
    </div>
  );
};

export default ColumnGroup;
